import React from 'react';
import { CheckCircle, Minus, Plus } from 'lucide-react';

export default function SetRow({
    set, sIdx, trackingKey, stepAmount, maxRest,
    cycleSetType, updateSetData, setWeightModal, toggleSet, isBarbell, showRpe
}) {
    let setBtnClass = "set-type-btn bg-zinc-900 border-zinc-700 text-gray-300";
    let setLabel = sIdx + 1;

    if (set.type === 'warmup') { setBtnClass = "bg-yellow-500 border-yellow-400 text-black"; setLabel = "W"; }
    if (set.type === 'dropset') { setBtnClass = "bg-red-500 border-red-400 text-white"; setLabel = "D"; }
    if (set.type === 'failure') { setBtnClass = "bg-purple-500 border-purple-400 text-white"; setLabel = "F"; }

    const currentReps = parseInt(set.reps, 10) || 0;
    const currentWeight = parseFloat(set.weight) || 0;
    const step = parseFloat(stepAmount) || 2.5;

    return (
        <div className={`workout-set-row ${set.done ? 'set-done bg-green-900/20 border-green-500/40' : 'bg-zinc-950 border-zinc-800'} grid grid-cols-[2.5rem_1fr_1fr_3rem] gap-2 items-center p-2 rounded-xl border transition-all duration-200`}>
            <button
                type="button"
                onClick={() => cycleSetType(trackingKey, sIdx)}
                className={`w-7 h-7 rounded-full border flex items-center justify-center font-black text-xs transition-colors mx-auto ${setBtnClass}`}
                title="Wissel Set Type (Normaal, Warmup, Dropset, Failure)"
            >
                {setLabel}
            </button>

            {/* REPS VAK */}
            <div className="set-input-box flex items-center justify-between bg-zinc-900 rounded-lg border border-zinc-700 h-9 px-1">
                <button
                    type="button"
                    onClick={() => updateSetData(trackingKey, sIdx, 'reps', Math.max(0, currentReps - 1))}
                    className="set-minus-btn w-7 h-7 flex items-center justify-center bg-red-500/15 text-red-400 rounded-md hover:bg-red-500/30 active:scale-95 transition-all shrink-0"
                >
                    <Minus size={14}/>
                </button>
                <input
                    type="number"
                    value={set.reps}
                    onFocus={(e) => e.target.select()}
                    onChange={(e) => updateSetData(trackingKey, sIdx, 'reps', e.target.value)}
                    className="set-value-text w-10 text-center font-black text-base sm:text-lg text-white bg-transparent outline-none border-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                />
                <button
                    type="button"
                    onClick={() => updateSetData(trackingKey, sIdx, 'reps', currentReps + 1)}
                    className="set-plus-btn w-7 h-7 flex items-center justify-center bg-emerald-500/15 text-emerald-400 rounded-md hover:bg-emerald-500/30 active:scale-95 transition-all shrink-0"
                >
                    <Plus size={14}/>
                </button>
            </div>

            {/* GEWICHT VAK: Drukken op het getal zelf opent ALTIJD de Gewicht & Barbell Platen Modal */}
            <div className="set-input-box flex items-center justify-between bg-zinc-900 rounded-lg border border-zinc-700 h-9 px-1">
                <button
                    type="button"
                    onClick={() => updateSetData(trackingKey, sIdx, 'weight', Math.max(0, Math.round((currentWeight - step) * 100) / 100))}
                    className="set-minus-btn w-7 h-7 flex items-center justify-center bg-red-500/15 text-red-400 rounded-md hover:bg-red-500/30 active:scale-95 transition-all shrink-0"
                >
                    <Minus size={14}/>
                </button>
                <button
                    type="button"
                    onClick={() => setWeightModal({
                        isOpen: true,
                        key: trackingKey,
                        sIdx: sIdx,
                        weight: set.weight,
                        isBarbell: isBarbell,
                        barWeight: 20
                    })}
                    className="set-weight-btn flex-1 h-full flex items-center justify-center font-black text-base sm:text-lg tabular-nums text-white hover:text-orange-500 bg-transparent outline-none transition-colors px-1 cursor-pointer"
                    title="Tik om gewicht in te voeren of barbell-platen te zien"
                >
                    {set.weight !== undefined && set.weight !== '' ? set.weight : 0}
                </button>
                <button
                    type="button"
                    onClick={() => updateSetData(trackingKey, sIdx, 'weight', Math.round((currentWeight + step) * 100) / 100)}
                    className="set-plus-btn w-7 h-7 flex items-center justify-center bg-emerald-500/15 text-emerald-400 rounded-md hover:bg-emerald-500/30 active:scale-95 transition-all shrink-0"
                >
                    <Plus size={14}/>
                </button>
            </div>

            <button
                type="button"
                onClick={() => toggleSet(trackingKey, sIdx, maxRest)}
                className={`set-check-btn h-9 w-full rounded-lg flex items-center justify-center transition-all duration-200 border ${set.done ? 'bg-green-600 text-white border-green-500 shadow-sm' : 'bg-zinc-900 text-green-500 border-zinc-700 hover:border-green-500'}`}
            >
                <CheckCircle size={18} fill={set.done ? "currentColor" : "none"} />
            </button>

            {showRpe && (
                <div className="col-span-4 flex items-center justify-between px-2 pt-1.5 pb-0.5 mt-0.5 border-t border-zinc-800">
                    <div className="flex items-center gap-2 text-xs text-gray-400">
                        <span title="Rate of Perceived Exertion (1-10)">RPE (1-10):</span>
                        <input
                            type="number"
                            min="1" max="10" step="0.5"
                            placeholder="-"
                            value={set.rpe || ''}
                            onChange={(e) => updateSetData(trackingKey, sIdx, 'rpe', e.target.value)}
                            className="w-12 bg-transparent text-orange-500 font-bold outline-none text-center border-b border-zinc-600 focus:border-orange-500 transition-colors [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
